module.exports = __webpack_public_path__ + "img/180.main_courses.78228102.svg";